export default "/_next/static/images/7-b025c241e4bbf40ff40938dda55e8ae6.png";